import { reportConstants } from "../constants/reportConstants";
import { reportService } from "../../services/API/reportService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";

export const dealActions = {
  saleReport
};

export const saleReport = formData => {
  return dispatch => {
    reportService.saleReport(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reportConstants.GET_SALESREPORT_REQUEST, data };
  }
  function success(data) {
    return { type: reportConstants.GET_SALESREPORT_SUCCESS, data };
  }
  function failure(error) {
    return { type: reportConstants.GET_SALESREPORT_FAILURE, error };
  }
};

export const refundReport = formData => {
  return dispatch => {
    reportService.refundReport(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reportConstants.GET_REFUNDREPORT_REQUEST, data };
  }
  function success(data) {
    return { type: reportConstants.GET_REFUNDREPORT_SUCCESS, data };
  }
  function failure(error) {
    return { type: reportConstants.GET_REFUNDREPORT_FAILURE, error };
  }
};

export const transactionReport = formData => {
  return dispatch => {
    reportService.transactionReport(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reportConstants.GET_TRANSACTIONREPORT_REQUEST, data };
  }
  function success(data) {
    return { type: reportConstants.GET_TRANSACTIONREPORT_SUCCESS, data };
  }
  function failure(error) {
    return { type: reportConstants.GET_TRANSACTIONREPORT_FAILURE, error };
  }
};

export const payoutReport = (url, merchantID = null, postData = null) => {
  return dispatch => {
    reportService.payoutReport(url, merchantID,  postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reportConstants.GET_PAYOUTREPORT_REQUEST, data };
  }
  function success(data) {
    return { type: reportConstants.GET_PAYOUTREPORT_SUCCESS, data };
  }
  function failure(error) {
    return { type: reportConstants.GET_PAYOUTREPORT_FAILURE, error };
  }
};

export const getReport = (formdata, url) => {
  return dispatch => {
    reportService.getReport(formdata, url).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reportConstants.POST_REPORT_REQUEST, data };
  }
  function success(data) {
    return { type: reportConstants.POST_REPORT_SUCCESS, data };
  }
  function failure(error) {
    return { type: reportConstants.POST_REPORT_FAILURE, error };
  }
}

export const merchantPayoutDetail = (postData) => {
  return dispatch => {
    reportService.merchantPayoutDetail(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reportConstants.GET_PAYOUTDETAIL_REQUEST, data };
  }
  function success(data) {
    return { type: reportConstants.GET_PAYOUTDETAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: reportConstants.GET_PAYOUTDETAIL_FAILURE, error };
  }
}

export const getMonth = (siteID) => {
  return dispatch => {
    reportService.getMonth(siteID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reportConstants.GET_MONTH_REQUEST, data };
  }
  function success(data) {
    return { type: reportConstants.GET_MONTH_SUCCESS, data };
  }
  function failure(error) {
    return { type: reportConstants.GET_MONTH_FAILURE, error };
  }
}


export const markPayment = (formData) => {
  return dispatch => {
    reportService.markPayment(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reportConstants.POST_MARKPAYMENT_REQUEST, data };
  }
  function success(data) {
    return { type: reportConstants.POST_MARKPAYMENT_SUCCESS, data };
  }
  function failure(error) {
    return { type: reportConstants.POST_MARKPAYMENT_FAILURE, error };
  }
}

export const addPayouComment = (formData) => {
  return dispatch => {
    reportService.addPayouComment(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reportConstants.POST_COMMENT_REQUEST, data };
  }
  function success(data) {
    return { type: reportConstants.POST_COMMENT_SUCCESS, data };
  }
  function failure(error) {
    return { type: reportConstants.POST_COMMENT_FAILURE, error };
  }
}
export const getPayoutComment = (formData) => {
  return dispatch => {
    reportService.getPayoutComment(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reportConstants.GET_COMMENT_REQUEST, data };
  }
  function success(data) {
    return { type: reportConstants.GET_COMMENT_SUCCESS, data };
  }
  function failure(error) {
    return { type: reportConstants.GET_COMMENT_FAILURE, error };
  }
}

export const getPayoutHistory = (formData) => {
  return dispatch => {
    reportService.getPayoutHistory(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reportConstants.GET_PAYOUTHISTORY_REQUEST, data };
  }
  function success(data) {
    return { type: reportConstants.GET_PAYOUTHISTORY_SUCCESS, data };
  }
  function failure(error) {
    return { type: reportConstants.GET_PAYOUTHISTORY_FAILURE, error };
  }
}




// WEBPACK FOOTER //
// ./src/app/redux/actions/reportAction.js